@if (items().length > 0) {
  <div
    class="tc-toast-outlet"
    role="region"
    aria-label="Oznámení"
    aria-live="polite"
    [style.zIndex]="toast.getZIndex()"
  >
    @for (item of items(); track item.id) {
      <div
        class="tc-toast"
        [attr.data-variant]="item.variant"
        role="status"
      >
        <i
          [attr.class]="'tc-toast__icon ' + iconFor(item.variant)"
          aria-hidden="true"
        ></i>
        <div class="tc-toast__body">
          @if (item.title) {
            <p class="tc-toast__title">{{ item.title }}</p>
          }
          <p class="tc-toast__message">{{ item.message }}</p>
        </div>
        @if (item.dismissible) {
          <button
            type="button"
            class="tc-toast__close"
            aria-label="Zavřít"
            (click)="dismiss(item)"
          >
            <i class="ri-close-line" aria-hidden="true"></i>
          </button>
        }
      </div>
    }
  </div>
}
